module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-area"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("請先選擇區域")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "area-wrap col-md-6 col-md-push-3"
  }, [_c('div', {
    staticClass: "select-marked",
    style: ({
      maxWidth: (_vm.column * 50) + 'px'
    })
  }, [_c('h4', [_vm._v("區域標誌")]), _c('p', {
    staticStyle: {
      "color": "#868686",
      "font-size": "14px"
    }
  }, [_vm._v("＊區域標誌的遊戲名只是建議喜愛該遊戲玩家可選購此區，並非強制此區域內玩家只能玩該款遊戲喔！＊")]), _vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7)])]), _c('div', {
    staticClass: "area-wrap col-md-12"
  }, [_vm._m(8), _c('div', {
    staticClass: "triger-row"
  }, _vm._l((_vm.getArea), function(area) {
    return _c('div', {
      staticClass: "triger-wrap",
      class: _vm.areaClass(area),
      on: {
        "click": function($event) {
          _vm.submitArea(area.section)
        }
      }
    }, [_c('div', {
      staticClass: "desc-wrap"
    }, [_c('div', [_vm._v("共 " + _vm._s(area.count) + " 個")])])])
  })), _c('div', {
    staticClass: "mb-30"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marked silent"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("潛水區")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marked integrated"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("綜合遊戲區")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marked steam"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("Steam區")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marked lol"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("英雄聯盟區")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marked fps"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("射擊遊戲區")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marked blizzard"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("暴雪遊戲區")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marked warfare"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("戰史遊戲區")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marked home"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("無限制區")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triger-row"
  }, [_c('div', {
    staticClass: "stage"
  }, [_c('img', {
    attrs: {
      "src": require("assets/stage.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fd5aa8a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/selectArea.vue
// module id = 564
// module chunks = 1